module.exports = window.$;


//////////////////
// WEBPACK FOOTER
// external "window.$"
// module id = 199
// module chunks = 221